// src/hooks/useScrollToHash.ts
import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook that handles scrolling to element by ID from URL hash
 */
const useScrollToHash = () => {
  const location = useLocation();

  const scrollToElement = useCallback((hash: string) => {
    // Remove the '#' character
    const id = hash.replace('#', '');
    const element = document.getElementById(id);

    if (element) {
      // Add a slight delay to ensure the page has fully rendered
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      return true;
    }
    return false;
  }, []);

  useEffect(() => {
    // Handle hash on initial page load and route changes
    if (location.hash) {
      // Wait for the DOM to be fully rendered
      setTimeout(() => {
        scrollToElement(location.hash);
      }, 300);
    } else {
      // Scroll to top when navigating to a page without hash
      window.scrollTo(0, 0);
    }
  }, [location, scrollToElement]);

  return scrollToElement;
};

export default useScrollToHash;
